import { categories } from './categories';

// Products linked to categories
export const products = [
    // Chicken
    { id: 'PRD-001', name: 'Chicken Breast (500g)', categoryId: 'CAT-RAW', price: 220, unit: 'pack' },
    { id: 'PRD-002', name: 'Chicken Drumstick (500g)', categoryId: 'CAT-RAW', price: 180, unit: 'pack' },
    { id: 'PRD-003', name: 'Whole Chicken (1kg)', categoryId: 'CAT-RAW', price: 320, unit: 'pack' },
    { id: 'PRD-004', name: 'Chicken Wings (500g)', categoryId: 'CAT-RAW', price: 200, unit: 'pack' },
    { id: 'PRD-005', name: 'Boneless Chicken (500g)', categoryId: 'CAT-RAW', price: 280, unit: 'pack' },
    { id: 'PRD-006', name: 'Chicken Keema (500g)', categoryId: 'CAT-RAW', price: 250, unit: 'pack' },

    // Ready to Cook Non-Veg
    { id: 'PRD-010', name: 'Chicken Tikka (300g)', categoryId: 'CAT-RTC-NV', price: 320, unit: 'pack' },
    { id: 'PRD-011', name: 'Butter Chicken Kit', categoryId: 'CAT-RTC-NV', price: 380, unit: 'kit' },
    { id: 'PRD-012', name: 'Tandoori Chicken (400g)', categoryId: 'CAT-RTC-NV', price: 350, unit: 'pack' },
    { id: 'PRD-013', name: 'Chicken Seekh Kebab (6pc)', categoryId: 'CAT-RTC-NV', price: 280, unit: 'pack' },
    { id: 'PRD-014', name: 'Chicken Nuggets (300g)', categoryId: 'CAT-RTC-NV', price: 220, unit: 'pack' },
    { id: 'PRD-015', name: 'Marinated Wings (500g)', categoryId: 'CAT-RTC-NV', price: 290, unit: 'pack' },

    // Ready to Cook Veg
    { id: 'PRD-020', name: 'Paneer Tikka Kit (300g)', categoryId: 'CAT-RTC-V', price: 220, unit: 'kit' },
    { id: 'PRD-021', name: 'Veg Seekh Kebab (6pc)', categoryId: 'CAT-RTC-V', price: 180, unit: 'pack' },
    { id: 'PRD-022', name: 'Stuffed Paratha (4pc)', categoryId: 'CAT-RTC-V', price: 120, unit: 'pack' },
    { id: 'PRD-023', name: 'Veg Momos (12pc)', categoryId: 'CAT-RTC-V', price: 150, unit: 'pack' },

    // Eggs
    { id: 'PRD-030', name: 'Farm Fresh Eggs (6pc)', categoryId: 'CAT-EGG', price: 48, unit: 'tray' },
    { id: 'PRD-031', name: 'Farm Fresh Eggs (12pc)', categoryId: 'CAT-EGG', price: 90, unit: 'tray' },
    { id: 'PRD-032', name: 'Farm Fresh Eggs (30pc)', categoryId: 'CAT-EGG', price: 210, unit: 'tray' },
    { id: 'PRD-033', name: 'Organic Eggs (6pc)', categoryId: 'CAT-EGG', price: 72, unit: 'tray' },

    // Oil
    { id: 'PRD-040', name: 'Sunflower Oil (1L)', categoryId: 'CAT-OIL', price: 180, unit: 'bottle' },
    { id: 'PRD-041', name: 'Mustard Oil (1L)', categoryId: 'CAT-OIL', price: 200, unit: 'bottle' },
    { id: 'PRD-042', name: 'Olive Oil (500ml)', categoryId: 'CAT-OIL', price: 450, unit: 'bottle' },
    { id: 'PRD-043', name: 'Groundnut Oil (1L)', categoryId: 'CAT-OIL', price: 220, unit: 'bottle' },

    // Masala
    { id: 'PRD-050', name: 'Chicken Masala (100g)', categoryId: 'CAT-MSL', price: 65, unit: 'pack' },
    { id: 'PRD-051', name: 'Biryani Masala (50g)', categoryId: 'CAT-MSL', price: 55, unit: 'pack' },
    { id: 'PRD-052', name: 'Garam Masala (100g)', categoryId: 'CAT-MSL', price: 75, unit: 'pack' },
    { id: 'PRD-053', name: 'Tikka Masala (100g)', categoryId: 'CAT-MSL', price: 60, unit: 'pack' },
    { id: 'PRD-054', name: 'Tandoori Masala (100g)', categoryId: 'CAT-MSL', price: 70, unit: 'pack' },

    // Others
    { id: 'PRD-060', name: 'Basmati Rice (1kg)', categoryId: 'CAT-OTH', price: 180, unit: 'pack' },
    { id: 'PRD-061', name: 'Butter (100g)', categoryId: 'CAT-OTH', price: 55, unit: 'pack' },
    { id: 'PRD-062', name: 'Cheese Slice (200g)', categoryId: 'CAT-OTH', price: 120, unit: 'pack' },
    { id: 'PRD-063', name: 'Cream (200ml)', categoryId: 'CAT-OTH', price: 85, unit: 'pack' },
];

// Helper functions
export function getProductById(productId) {
    return products.find(prod => prod.id === productId);
}

export function getProductsByCategory(categoryId) {
    return products.filter(prod => prod.categoryId === categoryId);
}

export function getRandomProduct(categoryId = null) {
    const pool = categoryId ? getProductsByCategory(categoryId) : products;
    return pool[Math.floor(Math.random() * pool.length)];
}

export default products;
